import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import { Button, Modal } from 'reactstrap';
import { LABEL_POSITION_TOP } from '../Common/constant';
import {
  signupModal,
  loginModal,
  validateEmailForAppUser,
  signUp,
  signupAppuserEmail
} from '../../actions';
import CourseCheckout from './course-checkout';
import SessionCheckout from './session-checkout';
import LocalStrings from '../../languages';
import {
  renderFieldText,
  renderFieldCheckbox,
  renderHiddenFieldText,
  validateEmail
} from '../Common/base-components';
import { showSuccess, showError, showWarning } from '../Common/alertmessage';

const Signup = props => {
  let { isLoggedIn, session, modalStatus, handleSubmit } = props;
  const [doPurchase, setPurchase] = useState(false);
  const [loading, setLoading] = useState(false);
  // console.log('signup modalStatus :- ', modalStatus);

  useEffect(() => {
    if (isLoggedIn == true && modalStatus.purchaseType) {
      setPurchase(true);
    }
  }, []);

  const closeModal = () => {
    props.signupModal({ showModal: false });
    setPurchase(false);
  };

  const openLoginModal = () => {
    closeModal();

    if (isLoggedIn == false && modalStatus.purchaseType) {
      props.loginModal({
        showModal: true,
        purchaseType: modalStatus.purchaseType,
        details: modalStatus.details
      });
    } else {
      props.loginModal({ showModal: true });
    }
  };

  const onSubmitForm = values => {
    // console.log('values:- ', values);
    setLoading(true);
    props.validateEmailForAppUser(session, values, response => {
      if (response.success === 0) {
        showError(LocalStrings.kSomethingWrong);
        setLoading(false);
      } else if (response.success === 2) {
        showError(LocalStrings.signup_error_already_registered);
        setLoading(false);
      } else {
        props.signUp(session, values, res => {
          // console.log('signup response in call back', res);

          setLoading(false);
          if (res.success) {
            props.signupAppuserEmail(session, values.email);
          }
          // console.log('modalStatus: ', modalStatus);
          if (modalStatus.purchaseType && modalStatus.purchaseType != '') {
            let myCourseAccess = res.data.appuser_access_by_appuserid;

            let matched = _.filter(myCourseAccess, obj => {
              return obj.courseid === modalStatus.details.courseid;
            });

            if (matched.length > 0) {
              closeModal();
            } else {
              setPurchase(true);
            }
          } else {
            closeModal();
          }
        });
      }
    });
  };

  return (
    <>
      <Modal
        className="login-modal"
        isOpen={modalStatus && modalStatus.showModal == true ? true : false}
      >
        <div className="modal-header">
          <div className="modal-title custom-text2-medium-primary">
            {doPurchase
              ? LocalStrings.checkout_title_checkout
              : LocalStrings.button_signup}
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => closeModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {doPurchase == true ? (
            <div>
              {modalStatus.purchaseType === 'course' ? (
                <CourseCheckout
                  printList={modalStatus.details}
                  history={props.history}
                  closeModal={closeModal}
                />
              ) : (
                <SessionCheckout
                  printList={modalStatus.details}
                  history={props.history}
                  closeModal={closeModal}
                />
              )}
            </div>
          ) : (
            <>
              <div className="custom-text5-bold mb-3">
                <span className="custom-text-color">//</span>{' '}
                {LocalStrings.button_signup}
              </div>
              <form onSubmit={handleSubmit(onSubmitForm)}>
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="firstname"
                      label={LocalStrings.form_label_firstname}
                      placeholder={LocalStrings.form_ph_firstname}
                      type="text"
                      component={renderFieldText}
                      labelposition={LABEL_POSITION_TOP}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="lastname"
                      label={LocalStrings.form_label_lastname}
                      placeholder={LocalStrings.form_ph_lastname}
                      type="text"
                      component={renderFieldText}
                      labelposition={LABEL_POSITION_TOP}
                    />
                  </div>
                </div>
                <Field
                  name="email"
                  label={LocalStrings.kYourEmailAddress}
                  placeholder={LocalStrings.kSupportEnterEmail}
                  type="text"
                  component={renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
                <Field
                  name="password"
                  label={LocalStrings.login_form_label_password}
                  placeholder={LocalStrings.login_form_ph_password}
                  type="password"
                  component={renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
                <div className="row form-group">
                  <div className="col-12">
                    <Field
                      name="terms_policy"
                      type="checkbox"
                      label="I accept the terms of service & privacy policy"
                      component={renderFieldCheckbox}
                    />
                  </div>
                  <div className="col-12">
                    <Field
                      name="terms_policyerror"
                      component={renderHiddenFieldText}
                      type="input"
                    />
                  </div>
                </div>
                <Button
                  className="custom-button-primary-lg w-100"
                  disabled={loading}
                >
                  <i className={loading ? `fa fa-refresh fa-spin` : ''}></i>
                  &ensp;
                  {LocalStrings.button_signup}
                </Button>
              </form>
              <div className="mt-4 text-center">
                <span className="custom-text1-medium">
                  {LocalStrings.signup_text_already_an_account}
                </span>{' '}
                <span className="custom-link1" onClick={openLoginModal}>
                  {LocalStrings.kLoginText}
                </span>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};

const validate = values => {
  var errors = {};
  var fistname = values['fistname'];
  var lastname = values['lastname'];
  var email = values['email'];
  var password = values['password'];
  var terms_policy = values['terms_policy'];

  if (!fistname || fistname.trim() === '') {
    errors['fistname'] = LocalStrings.requird;
  }
  if (!lastname || lastname.trim() === '') {
    errors['lastname'] = LocalStrings.requird;
  }
  if (!email || email.trim() === '') {
    errors['email'] = LocalStrings.requird;
  } else if (email && !validateEmail(email)) {
    errors['email'] = LocalStrings.invalid_email;
  }
  if (!password || password.trim() === '') {
    errors['password'] = LocalStrings.requird;
  }
  if (!terms_policy) {
    errors['terms_policyerror'] = LocalStrings.required_terms_condition;
  }

  return errors;
};

const mapStateToProps = state => ({
  isLoggedIn: state.isLoggedIn,
  session: state.session,
  modalStatus: state.signupModal
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      signupModal,
      loginModal,
      validateEmailForAppUser,
      signUp,
      signupAppuserEmail
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: 'SignupForm'
  })(Signup)
);
